import React, { useRef, useContext, useState, useEffect, useCallback } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import LogicContext from "../../Context/LogicContext";
import { toLowercaseKeys } from "../../helpers/toLowerCaseKeys";
import { SetStockOpeningEdit } from "../../store/stockOpeningAtom";
import { Dropdown } from 'react-bootstrap';
import StockOpeningScroll from "./StockOpeningScroll";
import { stockOpeningService } from "../../services/stockOpening.service";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";


const StockOpeningDetailsPage = () => {
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setStockEdit = SetStockOpeningEdit();

  const { id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [stockDetails, setStockDetails] = useState({
    opening_main: [],
    opening_details: [],
    action_status: [],
  });

  const { pathname } = useLocation();
  const printRef = useRef(null);

  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "Stock Opening Details";
    let isMounted = true;

    if (isMounted) {
      loadDetailsData();
    }

    return () => {
      isMounted = false;
    };
  }, [id]);


  const loadDetailsData = () => {
    stockOpeningService.stockOpeningDetails(id).then((response) => {
      if (response.data) {
        setStockDetails(response.data);
      }
    });
  }

  const editCurrentData = async () => {
    const response = await myPromiseModal({
      title: "Modify Opening",
      body: "Do you want to modify this record?",
      showInput: false,
    });

    if (response.decision === true) {
      setStockEdit(stockDetails);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };


  



  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Stock_Opening_${stockDetails?.opening_main?.[0]?.ref_no}`,
    onAfterPrint: () => console.log("Printed successfully"),
  });

  const onSelection = (list) => {
    const tempList = list?.filter((item) => item.checked === true);
    setSelectedList(tempList);
  };

  const getStatusColor = (statusName) => {
    switch (statusName) {
      case "Approved":
        return "bg-green-100 text-green-700";
      case "Pending For Approval":
        return "bg-yellow-100 text-yellow-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

    const viewItemDetails = useCallback(
      adId => {
        navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
      },
      [currModuleId, currModuleName, navigate]
    );

  return (
    <section className="mt-4 w-full mx-auto px-4 sm:px-6 lg:px-8">
     

      <div className="flex justify-end gap-3 mb-6">
      
        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          <img src={printer} alt="Print" className="w-5 h-5" />
          <span className="hidden sm:inline">Print</span>
        </button>

        <button
          onClick={editCurrentData}
          className="p-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 transition"
          title="Edit"
        >
          <img src={pencil} alt="Edit" className="w-6 h-6" />
        </button>

        <button
          // onClick={deleteCurrentData}  ← uncomment when delete logic is ready
          className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition opacity-50 cursor-not-allowed"
          title="Delete (not implemented)"
        >
          <img src={trash} alt="Delete" className="w-6 h-6" />
        </button>
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* Left Sidebar - Scroll List */}
        <div className="">
          <StockOpeningScroll onSelection={onSelection} viewItemDetails={viewItemDetails} />
        </div>

        {/* Main Details Card - PRINTABLE AREA */}
        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl overflow-hidden">
          <div className="p-6 lg:p-8">
            {/* Header */}
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b pb-4 mb-6">
              <div>
                <h1 className="text-2xl font-bold text-gray-800">Stock Opening Details</h1>
                <p className="text-sm text-gray-500 mt-1">
                  Ref No: {stockDetails?.opening_main?.[0]?.ref_no || "-"}
                </p>
              </div>
              {/* <span
                className={`mt-3 sm:mt-0 px-4 py-2 rounded-full text-sm font-medium ${getStatusColor(
                  stockDetails?.adjustment_main?.[0]?.status_name
                )}`}
              >
                {stockDetails?.adjustment_main?.[0]?.status_name || "—"}
              </span> */}
            </div>

            {/* Info Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div>
                <p className="text-sm text-gray-500">Reference No</p>
                <p className="font-semibold">{stockDetails?.opening_main?.[0]?.ref_no || "—"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Last Change Date</p>
                <p className="font-semibold">{stockDetails?.opening_main?.[0]?.last_changed_date_string || "—"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Warehouse</p>
                <p className="font-semibold">{stockDetails?.opening_main?.[0]?.warehouse_name || "—"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Encoded Date</p>
                <p className="font-semibold">{stockDetails?.opening_main?.[0]?.encoded_date_string || "—"}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Encoded By</p>
                <p className="font-semibold">{stockDetails?.opening_main?.[0]?.encoded_by_name || "—"}</p>
              </div>
           
             
              <div className="sm:col-span-2">
                <p className="text-sm text-gray-500">Remarks</p>
                <p className="font-medium">{stockDetails?.opening_main?.[0]?.adjustment_remark || "—"}</p>
              </div>
            </div>

            {/* Line Items Table */}
            <div>
              <h2 className="text-lg font-semibold text-gray-800 mb-4">Line Items</h2>
              <div className="overflow-x-auto border rounded-lg">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
                    <tr>
                      <th className="px-4 py-3 text-left">Item</th>
                      <th className="px-4 py-3 text-left">SKU</th>
                      <th className="px-4 py-3 text-left">Type</th>
                      <th className="px-4 py-3 text-left">Category</th>
                      <th className="px-4 py-3 text-center">Unit</th>
                      <th className="px-4 py-3 text-center">Qty</th>
                      <th className="px-4 py-3 text-center">Rate</th>
                      <th className="px-4 py-3 text-center">Sum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stockDetails?.opening_details?.length > 0 ? (
                      stockDetails.opening_details.map((item) => (
                        <tr key={item.item_id} className="border-b hover:bg-gray-50">
                          <td className="px-4 py-3">{item.item_name}</td>
                          <td className="px-4 py-3 text-gray-600">{item.item_sku}</td>
                          <td className="px-4 py-3">{item.item_type_name}</td>
                          <td className="px-4 py-3">{item.item_category_name}</td>
                          <td className="px-4 py-3 text-center">{item.item_unit_name}</td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">
                            {item.item_quantity}
                          </td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">
                            {formatCustomNumber(item.item_rate)}
                          </td>
                          <td className="px-4 py-3 text-center font-bold text-gray-800">
                            {formatCustomNumber(item?.item_rate * item?.item_quantity )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center py-8 text-gray-500">
                          No line items found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StockOpeningDetailsPage;